export const SalaryDecisionEN = {
    "salaryDecision" : {
        "headingAdd": "Add Salary Decision",
        "headingUpdate": "Update Salary Decision",
            "placeHolder": {
            "salaryDecisionCode": "QD001",
                "decisionDate": "dd/mm/yyyy",
                "positionDecision": "Position Company",
                "effectDate": "dd/mm/yyyy",
                "employee": "Employee",
                "reason": "Reason",
                "fromDate": "dd/mm/yyyy",
                "note": "Note",
                "salaryTypes": "Salary Types",
                "allowances": "Allowances",
                "money": "Money"
        },
        "label": {
            "salaryDecisionCode": "Code",
                "decisionDate": "Decision date",
                "positionDecision": "Position decision",
                "effectDate": "Effect date",
                "employee": "Employee",
                "decSalaryAllowances": "Salary Allowances:",
                "reason": "Reason",
                "fromDate": "From date",
                "note": "Note",
                "salaryTypes": "Salary Types",
                "decPrimaryMoney": "Money",
                "allowances": "Allowances",
                "decMoneyBenefit": "Money",
                "oldSalary": "Old salary",
                "oldAllowance": "Old allowance",
                "status": "Status",
                "pending": "Pending",
                "approved": "Approved",
                "reject": "Reject",
                "trashed": "Trashed"
        },
        "detail": {
            "heading": "Salary decision detail",
                "generalInformation": "General Information",
                "oldSalaryInformation": "Old salary information",
                "newSalaryInformation": "New salary information",
                "newAllowanceInformation": "New allowance information"
        },
        "message": {
            "effectDateException": "Effect date cant before Decision date",
                "fromDateException": "From date cant before Decision date",
                "allowanceDuplicate": "Allowance duplicate",
                "salaryTypeDuplicate": "Salary type duplicate",
                "add": "Add success",
                "update": "Update success",
                "error": "Error",
                "required": {
                "salaryDecisionCode": "Salary decision code is required",
                    "decisionDate": "Please select decision date",
                    "positionDecisionId": "Please select position decision",
                    "effectDate": "Please select effect date",
                    "employeeId": "Please select employee",
                    "fromDate": "Please select from date",
                    "salaryTypes": "Please select salary type",
                    "allowances": "Please select allowance",
                    "money": "Money is required"
            }
        }
    }
}